// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"Layout_pageContainer__IvFw2","mainContent":"Layout_mainContent__FnV3k"};